import { isRouteErrorResponse } from "react-router";

export function getErrorMessage(error: unknown): string {
	if (isRouteErrorResponse(error)) {
		return error.statusText || error.data?.message || "Unknown error";
	}
	if (error instanceof Error) {
		return error.message;
	}
	return "Unknown error";
}
